import { FEATURE_FLAG_KEYS, useFeatureFlags } from '@core/utils/flags';
import { PATHS } from '@core/routes';
import { HFSpinner } from '@hf/designSystem/v1';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { TearsheetsLandingPage } from '../pages/LandingPage';

/**
 * Frontend-only product gate.
 * - `tearsheets` off → hide product (redirect home)
 * - `tearsheets` on + `tearsheets/is_subscriber` off → animated subscribe landing
 * - both on → full Tearsheets SPA
 */
export function TearsheetsGate({ children }: { children: ReactNode }) {
  const { ready, isEnabled } = useFeatureFlags();

  if (!ready) {
    return <HFSpinner center sx={{ minHeight: '40vh' }} />;
  }

  if (!isEnabled(FEATURE_FLAG_KEYS.tearsheets)) {
    return <Navigate to={PATHS.home} replace />;
  }

  if (!isEnabled(FEATURE_FLAG_KEYS.tearsheetsIsSubscriber)) {
    return <TearsheetsLandingPage />;
  }

  return children;
}
